import { DatePipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'sqep-footer',
  imports: [DatePipe, NgOptimizedImage],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  copyrightDate = Date.now();
  isSignedIn = input<boolean>();
  navbarBgClass = input<string>();
  appVersion = input<string>();
}
